import { useContext } from 'react';
import authContext from '../context/authContext';

export default function useAuth() {
  const context = useContext(authContext);

  if (!context) throw new Error('context must be use inside provider');

  return context;
}
